import axios from 'axios';
const church = {
	state: {		
        churchDetail : null				
	},	
	mutations: {		
		churchDetail_success(state, payload){
			state.churchDetail = payload			
        }		
	},
	actions: {
		processchurch(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Church/ProcessChurch', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {	                   									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},
		getchurchall(){
			return new Promise((resolve, reject) => {				
				axios.get('/Church/GetChurchAll')
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},  	
		getchurch({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Church/GetChurch?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getchurchbyusername({commit, rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Church/GetChurchbyUsername?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {	
					commit('churchDetail_success',respdata);					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},  
		getchurchbyid({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get('/Church/GetChurchbyId?Id='+Id+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getchurchbysearch({rootState},searchVal){
			return new Promise((resolve, reject) => {				
				axios.get('/Church/GetChurchbySearch?SearchItem='+searchVal+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default church